/**
 * jQuery.browser.mobile (http://detectmobilebrowser.com/)
 * jQuery.browser.mobile will be true if the browser is a mobile device
 **/
(function(a){
	(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|ad|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))
})(navigator.userAgent||navigator.vendor||window.opera);

function popupsOnLoad(){
	var queryString        = document.location.hash || document.location.search;
    let requestDemoPattern = /\brequestdemo\b/i;
    let signUpPattern      = /\bsignup\b/i;
    let getQuotePattern    = /\bgetquote\b/i;

    if (queryString == '') {
        return;
    }

    queryString = queryString.toLowerCase();

    var popupTimeout = window.setTimeout(function() {
        if (requestDemoPattern.test(queryString)) {
            if (jQuery('.popup-demo').length > 0) {
                jQuery('.popup-demo:first').click();
            } else if (jQuery('.popup-threefields').length > 0) {
                jQuery('.popup-threefields:first').click();
            } else if (jQuery('.popup-desktop-country-phone').length > 0) {
                jQuery('.popup-desktop-country-phone:first').click();
            }
        } else if (signUpPattern.test(queryString)) {
            jQuery('.popup-signup:first').click();
        } else if (getQuotePattern.test(queryString)) {
            jQuery('.popup-goute:first').click();
        }
        
        clearTimeout(popupTimeout);
    }, 1000);
}
// popupsOnLoad();

function is_touch_device(){
	try{
		document.createEvent("TouchEvent");
		if(jQuery(window).width()<=768){
			return true;
		}else{
			return false;
		}

	}catch(e){
		return false;
	}
}

function launchCarousel(){
	const bxslider = jQuery('.bxslider');

	jQuery('.carousel').carousel({
		interval:false
	});
	if( bxslider.length > 0 ){
		bxslider.css('opacity',1).bxSlider({
			minSlides:1,
			maxSlides:10,
			slideWidth:'auto',
			responsive:true,
			slideMargin:50,
			ticker:true,
			pager:true,
			speed:40000,
			preloadImages:'all',
			onSliderLoad:function(){
				setTimeout(function(){
					bxslider.css('visibility','visible')
				},1000);
			}
		});
	}
}

function fadeOutBasic1(){
	jQuery(".digital-platform .violet .basic").css({
		"-webkit-animation-name":"fadeInUp",
		"animation-name":"fadeInUp",
		"opacity":1
	});
}

function fadeOutBasic2(){
	jQuery(".digital-platform .blue .basic").css({
		"-webkit-animation-name":"fadeInUp",
		"animation-name":"fadeInUp",
		"opacity":1
	});
}

function fadeOutBasic3(){
	jQuery(".digital-platform .light-blue .basic").css({
		"-webkit-animation-name":"fadeInUp",
		"animation-name":"fadeInUp",
		"opacity":1
	});
}
jQuery(document).ready(function(){
	var IpadWidth=1366;
	var mobileLarge=760;
	var mobileWidth=738;
	var mobileMenuParallax=1024;
	var width=jQuery(window).width();
	var scrollTop=jQuery(window).scrollTop();
	var window_size,menu,value;
	var supportsBackgroundBlendMode=window.getComputedStyle(document.body).backgroundBlendMode;

	// if(is_touch_device() && jQuery(window).width() > mobileLarge){
	//     jQuery(".parallax .digital").css({"padding-top": "180px", "padding-bottom":"100px"});
	//}
	if(supportsBackgroundBlendMode){
		jQuery('body').addClass('bg_blend_mode__on');
	}else{
		jQuery('body').addClass('bg_blend_mode__off');
	}

	if(jQuery.browser.mobile){
		jQuery('body').addClass('is_mobile');
	}else{
		jQuery('body').addClass('is_desktop');
	}

	function collapseToggler(){
		jQuery('.colapse_toggler').on('click',function(e){

			var jQuerywrapper=jQuery(this).closest('.colapse_block'),
			jQuerycontent=jQuerywrapper.find('.colapse_content');

			jQuerywrapper.toggleClass('expand');
			jQuerycontent.slideToggle();
		})
	}
	collapseToggler();

	function equalCollumnsManage(jQuerycolumns){
		if(!jQuerycolumns||jQuerycolumns.find('.expand').length){
			return false;
		}

		var height=0;
		jQuerycolumns.each(function(){
			var thisHeight=jQuery(this).outerHeight();
			height=height>thisHeight ? height : thisHeight;
		});

		jQuerycolumns.css('min-height',height);
	}

	if(window.innerWidth>=992){
		equalCollumnsManage(jQuery('.interview_questions__column_inner'));
	}

	jQuery(window).on('resize', function(){
		if(window.innerWidth>=992){
			equalCollumnsManage(jQuery('.interview_questions__column_inner'));
		}
	});

	function setMouseOverEvents(){
		var lastItem='';

		jQuery(".started").on('mouseover', function() {
                    var id = jQuery(this).attr('id');
                     if (!jQuery(this).hasClass("hover")) {
                         //if (lastItem != 'last') {
                         //if (lastItem != 'last') {
                         jQuery("menu ul>li").removeClass("hover");
                         jQuery(".sub").css("opacity", "0");
                         jQuery(".sub-menu").hide();
                         jQuery(".sub-menu figure, .sub-column").css("margin-top", "-20px");
                         jQuery(this).addClass("hover");
                         if (id.length) {
                             jQuery("." + id).parent(".sub-menu").show();
                             jQuery("." + id).animate({
                                 opacity: "1"
                             }, 500);
                             jQuery("." + id + " figure, ." + id + " .sub-column").animate({
                                 marginTop: "20px"
                             }, 500);
                             /*if (jQuery(this).hasClass('last-menu-item')) {
                                 lastItem = 'last';
                                 setTimeout(function() {
                                     lastItem = '';
                                 }, 750);
                             }*/
                         }
                         //}
                     }
                 });

		function hideMenu(){
			jQuery(".sub-menu").hide();
			jQuery(".sub").css("opacity","0");
			jQuery(".sub-menu figure, .sub-column").css("margin-top","-20px");
			jQuery("menu ul>li").removeClass("hover");
		}

		jQuery(document).on("click touchstart",function(e){
			var target=jQuery(e.target);
			var insideMenu=false;
			if(!(target.parents(".bottom-menu").length===1||target.parents(".sub-menu").length===1||target.is("div.sub-menu"))){
				insideMenu=true;
			}
			if(insideMenu){
				hideMenu();
			}
		});
		jQuery(document).on('mouseover', function(e){
			var target=jQuery(e.target);
			var insideMenu=false;

			if(!(target.parents(".bottom-menu").length===1||target.parents(".sub-menu").length===1||target.is("div.sub-menu"))){
				insideMenu=true;
			}
			if(insideMenu){
				hideMenu();
			}
		});
		jQuery(document).on('mouseleave', function(){
			hideMenu();
		});
		jQuery(".started").on('mouseover', function(){
			hideMenu();
		});
	}

	function setClickEvents(){

		jQuery(".bar").on('click',function(){

			var window_size,scrollTop,
			window_size=jQuery(window).height()-70;
			scrollTop=jQuery(window).scrollTop();
			jQuery(this).toggleClass("active");

			if(jQuery(this).hasClass("active")){

				sessionStorage.setItem("MarginTop",scrollTop); /* setting margin top property for mobile */

				jQuery(".menu-drop").fadeIn();
				jQuery(".menu-drop").animate({
					width:'100%'
				},function(){

					jQuery(".menu-drop ul:not(.hide), .buttons").fadeIn(300,function(){
						jQuery("body, html").addClass("static_mobile");
					});
					jQuery(".bar img").attr('src',"img/close.jpg");
				});
				jQuery(".bar").addClass("bar_opened").removeClass("bar_closed");
				;
				jQuery(".menu-small .logo img").fadeOut(500);
				jQuery(".menu-small").addClass("white-menu");

			}else{

				var mrg=sessionStorage.getItem("MarginTop");
				jQuery("body, html").removeClass("static_mobile");

				function hide(){
					jQuery(".menu-drop").animate({
						width:'0'
					});
					jQuery(".bar").addClass("bar_closed").removeClass("bar_opened");
					jQuery(".menu-small .logo img").fadeIn(600);
				}
				jQuery(".buttons, .menu-drop ul").fadeOut(300);
				setTimeout(hide,600);

				jQuery(window).scrollTop(mrg); /* scrolling to the position menu was opened */
			}
			setSmallMenu(window_size,scrollTop);
		});

		jQuery(".itemParent__abled").on('click', function(){

			var v=jQuery(this).siblings(".hide-parent");
			var img=jQuery(this).find("img");

			if(v.hasClass("opened")){
				jQuery(this).removeClass("itemParent_opened").addClass("itemParent_closed");
				animateRotate(img,0);
				v.toggleClass("opened");
				v.slideUp("slow");
			}else{
				jQuery(this).removeClass("itemParent_closed").addClass("itemParent_opened");
				animateRotate(img,90);
				v.toggleClass("opened");
				v.slideDown("slow");
			}
		});

		jQuery(".dropdown-toggle").dropdown();
	}

	function setSmallMenu(window_size,scrollTop){
		if(!jQuery(".bar").hasClass("active")&&width<=mobileMenuParallax){
			if(jQuery(".careers_jumbotron").length&&jQuery(window).width()<=320){
				window_size=50;
				
			}


			if(scrollTop>window_size){

				jQuery(".menu-small").addClass("green-menu").removeClass("white-menu");
				jQuery(".parallax-shadow").removeClass("parallax-top");
			}
			if(scrollTop<window_size){
				jQuery(".menu-small").removeClass("green-menu").addClass("white-menu");
				jQuery(".parallax-shadow").addClass("parallax-top");
			}
		}
	}

	function removeParallaxSmall(){
		if(jQuery(window).width()>=744){
			jQuery(".parallax-mobile").removeClass("parallax-small");
		}else{
			jQuery(".parallax-mobile").addClass("parallax-small");
		}
	}
	/*****************************
	 * ***************************
	 * @param {type} scrollTop***
	 * @returns {undefined}******
	 * setting menu desktop******
	 * **************************
	 * **************************/
	var jQueryshadow=false;
	if(jQuery(".parallax-shadow").length){
		jQueryshadow=true;
	}
	if(!jQueryshadow){
		jQuery(".menu-top, .menu-bottom").addClass("menu-white");
	}else{
		jQuery(".parallax-shadow, .parallax-banking").addClass("parallax-top");
	}

	jQuery(document).on('scroll', function(){
		if(!jQuery("html").hasClass("htmlno-scroll")){
			var y=jQuery(this).scrollTop();
			if(y>400){
				jQuery(".new-success__sticky-bar").css('display','flex');
			}else{
				jQuery(".new-success__sticky-bar").css('display','none')
			}
		}
	});

	function setMenu(scrollTop){
		if(width>mobileMenuParallax){
			var jQueryimg=jQuery('.menu .logo img');
			if(jQueryimg.length>0){
				var imgOffset=jQueryimg.offset().top;

				var distance=jQuery(".bottom-menu").offset().top;
				if(scrollTop>=imgOffset){
					jQuery(".menu .logo").addClass("logo-flex");
				}

				if(scrollTop>=distance){
					jQuery(".united_menu menu").addClass("menu-fixed");
					jQuery(".menu-bottom").removeClass("menu-white");
					jQuery(".menu-top").removeClass("active");

					setMarginSubMenu();
				}

				if(scrollTop<39){
					jQuery(".menu-top").addClass("active");
					jQuery(".menu .logo").removeClass("logo-flex");
					if(!jQueryshadow){
						jQuery(".menu-bottom").addClass("menu-white");
						jQuery(".menu-bottom, .menu-top").addClass("menu-shadow");
					}else{
						jQuery(".menu-bottom").addClass("menu-shadow");
						jQuery(".parallax-shadow, .parallax-banking").addClass("parallax-top");
					}
					jQuery(".united_menu menu").removeClass("menu-fixed");
					setMarginSubMenu();
				}

			}
		}
		/* if(jQuery(".new-success-top-menu").length){
		 if(scrollTop<39){
		 if (!jQuery("html").hasClass("htmlno-scroll")) {
		 alert("44");
		 jQuery(".new-success__sticky-bar").hide();
		 }
		 }
		 else {
		 if (!jQuery("html").hasClass("htmlno-scroll")) {
		 alert("55");
		 jQuery(".new-success__sticky-bar").show();
		 }
		 }
		 }*/
	}

	function setScrollEvents(){

		width=jQuery(window).width();

		function hideHeader(scrollTop){

			var height=jQuery(window).height();
			if(scrollTop<=height+height/2&&!is_touch_device()){
				jQuery(".digital, .header-container-main").show();
				jQuery(".bigtext, .smalltext, .free, .demo, .watch, .header-content, .watch").css({
					"opacity":"1",
					"animation-name":"none",
					"-webkit-animation-name":"none"
				});
			}

		}

		function secondSection(scrollTop,window_size){
			if(!is_touch_device()){
				value=scrollTop*2+800;
				if(value>=jQuery(window).height()){
					jQuery(".digital-platform .walkme-digital").css({
						"-webkit-animation-name":"fadeIn",
						"animation-name":"fadeIn",
						"opacity":1
					});
					setTimeout(fadeOutBasic1,700);
					setTimeout(fadeOutBasic2,900);
					setTimeout(fadeOutBasic3,1100);
				}else{
					jQuery(".digital-platform h4, .digital-platform .basic").css("opacity",0);
				}
			}
		}

		function setLPHeader(scrollTop){
			$wrapper=jQuery(".text.left-wrapper.clearfix");
			$section=jQuery(".top-img_old");
			$wr_height=parseInt($wrapper.outerHeight());
			$section_height=parseInt($section.outerHeight());
			
			if($wr_height>$section_height){
				var topMax=$wr_height-$section_height,
				jumbotronDigitalTop=scrollTop<topMax ? scrollTop : topMax;
				$wrapper.attr({
					'style':'top: '+-jumbotronDigitalTop+'px !important;'
				});

			}
		}
		window_size=jQuery(".parallax_height, .jumbotron-paralax, .jumbotron_banner, .parallax-contact, .black-paral.success").height()-70;
		window_size=SuccessFactors(window_size);
		window_size=CustomerHeight(window_size);
		if(window_size<0){
			window_size=350;
		}
		setSmallMenu(window_size,scrollTop);
		secondSection(scrollTop,window_size);
		if(scrollTop>1){
			setMenu(scrollTop);
		}

        jQuery(window).on('scroll', function() {
			window_size=jQuery(".parallax_height, .jumbotron-paralax, .jumbotron_banner, .parallax-contact, .black-paral.success").height()-70;
			scrollTop=jQuery(window).scrollTop()||document.body.scrollTop||document.documentElement.scrollTop;
			window_size=SuccessFactors(window_size);
			window_size=CustomerHeight(window_size);
			setMenu(scrollTop);
			setSmallMenu(window_size,scrollTop);
			if(is_touch_device()){
				hideHeader(scrollTop);
			}
			secondSection(scrollTop,window_size);
			animateAwards(scrollTop);
			//setBrands(scrollTop);
			jumbotronManage();
			setLPHeader(scrollTop);
		});
                
		jQuery(window).on('resize', setMenu,setSmallMenu,setMenu(scrollTop));
	}

	jQuery(window).on('scroll', function(){
		var scrollVal=jQuery(window).scrollTop();
		setBrands(scrollVal);
	});

	function CustomerHeight(window_size){
		if((jQuery(".parallax-customer").length>0)){
			var customerh=jQuery(".header-container-customer").outerHeight();
			window_size=window_size-customerh;
		}
		return window_size;
	}

	function SuccessFactors(window_size){
		if(jQuery(".parallax-success").length){
			var wb=jQuery(".white_box").height();
			window_size=window_size-wb-20;
		}
		return window_size;
	}

	function jumbotronManage(){
		var jQueryjumbotron=jQuery('.jumbotron_banner');

		if(jQueryjumbotron.hasClass('cancel_fixed')){
			return false;
		}

		var jQueryjumbotronPoster=jQuery('.jumbotron_banner__poster'),
		jQueryjumbotronDigital=jQueryjumbotron.find('.digital'),
		jumbotronHeight=parseInt(jQueryjumbotronDigital.outerHeight()),
		scrollTop=parseInt(jQuery(window).scrollTop()),
		windowHeight=parseInt(jQuery(window).height());

		jQueryjumbotron
		.height(jumbotronHeight)
		.addClass('fixed');
		jQueryjumbotronPoster.height(jumbotronHeight);

		if(jumbotronHeight>windowHeight){
			var topMax=jumbotronHeight-windowHeight,
			jumbotronDigitalTop=scrollTop<topMax ? scrollTop : topMax;
			var careersTop=0;

			jQueryjumbotronDigital.attr({
				'style':'top: '+-jumbotronDigitalTop+'px !important;'
			});
			jQueryjumbotronPoster.css('top',-jumbotronDigitalTop+'px');
		}else if(scrollTop!==0){
			jQueryjumbotronDigital.removeAttr('style');
			jQueryjumbotronPoster.css('top','auto');
		}
	}

	function testimonialGallerySlider(){
		var $testimonialGallery=jQuery('#testimonial_gallery');
		if(!$testimonialGallery.length)
			return false;

		$testimonialGallery.slick({
			fade:true
		});
	}
	testimonialGallerySlider();

	function setBrands(scrollTop){
		if(jQuery(".wrapper-brands").length){
			var menu,size;
			size=jQuery(window).height()/2;

			if(width<=mobileWidth){
				menu=jQuery("menu").height();
			}else{
				menu=jQuery(".menu-small").height();
			}
			var brandsOffset=jQuery(".wrapper-brands").offset().top;

			if((scrollTop+menu+size)>brandsOffset){
				jQuery(".play-btn").css({
					"-webkit-animation-name":"fadeIn",
					"animation-name":"fadeIn",
					"display":"flex",
					"display": "-webkit-box",
					"display": "-moz-box",
					"display": "-ms-flexbo",
					"display": "-webkit-flex",
					"-webkit-box-align":"center",
					"-moz-box-align":"center",
					"-ms-flex-align":"center",
					"-webkit-align-items":"center",
					"align-items":"center",
					"-webkit-justify-content":"center",
					"justify-content":"center",
					"opacity":1
				});
				if(is_touch_device()){
					setTimeout(animateFirstText,100);
					setTimeout(animateSecondText,200);
					setTimeout(animateSmallText,300);
				}else{
					setTimeout(animateFirstText,200);
					setTimeout(animateSecondText,400);
					setTimeout(animateSmallText,600);
				}

				function animateFirstText(){
					jQuery(".brand--text.first").css({
						"-webkit-animation-name":"fadeInUp",
						"animation-name":"fadeInUp",
						"opacity":1
					});
				}

				function animateSecondText(){
					jQuery(".brand--text.second").css({
						"-webkit-animation-name":"fadeInUp",
						"animation-name":"fadeInUp",
						"opacity":1
					});
				}

				function animateSmallText(){
					jQuery(".brand--small-text").css({
						"-webkit-animation-name":"fadeInUp",
						"animation-name":"fadeInUp",
						"opacity":1
					});
				}
			}
		}
	}

	function animateRotate(img,angle){
		var jQueryelem=jQuery(img);

		jQuery({
			deg:0
		}).animate({
			deg:angle
		},{
			duration:500,
			step:function(now){
				jQueryelem.css({
					transform:'rotate('+now+'deg)'
				});
			}
		});
	}

	function setNavs(){
		jQuery(".nav-tabs li").on('mouseup', function(){

			jQuery(".tab-content .caption").fadeOut();
			setTimeout(change,200);

			function change(){
				jQuery(".tab-content > .tab-pane").fadeOut();
				setTimeout(showActive,400);

				function showActive(){
					jQuery(".tab-content > .active").fadeIn(function(){
						jQuery(".tab-content .active .caption").fadeIn();
					});
				}
			}
		});
	}

	/* Events page to fix calendar height */

	function EventsHeightBoxes(){

		function getMaxOfArray(numArray){
			return Math.max.apply(null,numArray);
		}

		function SetHeightEvents($element){

			jQuery(".calendar__parent").each(function(index){
				var textHeight=[];
				jQuery(this).find(".calendar__child").each(function(index){
					var height=parseInt(jQuery(this).find($element).height());

					textHeight.push(height);

				});

				var tmp=0;
				var len=textHeight.length;

				for(var i=0;i<=len;i++){
					if(i%4==0&&i>1){
						var slice=textHeight.slice(tmp,i);
						var max=getMaxOfArray(slice);
						jQuery(this).find(".calendar__child").each(function(index){

							for(var d=tmp;d<=i;d++){
								if(index==d){
									jQuery(this).find($element).height(max);
								}
							}
						});
						tmp=i;
					}
				}
				var tail=textHeight.slice(tmp,len);
				if(tail.length<4&&tail.length>1){
					var max=getMaxOfArray(tail);
					jQuery(this).find(".calendar__child").each(function(index){

						for(var d=tmp;d<=len;d++){
							if(index==d){
								jQuery(this).find($element).height(max);
							}
						}
					});
				}
			});
		}
		SetHeightEvents(".landscape__date");
		SetHeightEvents(".title_events");
	}

	/* Events page to fix calendar height */

	function resizeEvents(){

		EventsHeightBoxes();
		setScrollEvents();
		setVisaBackground();
		//setWhiteBox();
		setCustomer();
		jumbotronManage();
		setMarginSubMenu();
		setIpad();
		scrollTop=jQuery(window).scrollTop();
		setMenu(scrollTop);
		setParallax();
		removeParallaxSmall();
		setHeaderCustomer();
		setSuccessTemplate();
		setCareers();
	}

	// Listen for orientation changes
	window.addEventListener("orientationchange",function(){
		setIpad();
		setSuccessTemplate();
		setMarginSubMenu();
		setCareers();
	},false);

	function setMarginSubMenu(){

		var mh=jQuery(".menu").height();
		if(!jQuery(".menu-top").hasClass("active")){
			mh=mh-40;
		}
		jQuery(".sub-menu").css("margin-top",mh);
	}

	function setGuidance(){
		jQuery(".carousel-indicators > li").on('click', function(){
			if(!jQuery(this).hasClass("active")){
				var img=jQuery(this).attr("class");
				switchTab(img);
			}
		});
		jQuery(".right-row").on('mouseover', function(){
			jQuery(this).css("opacity","0.1");
		});
		jQuery(".right-row").on('mouseout', function(){
			jQuery(this).css("opacity","0.3");
		});

		jQuery(".right-row").on('click', function(){
			var target=jQuery(this).attr("target");
			switchTab(target);
		});
	}


	function switchTab(img){

		jQuery(".image-desktop img:not(.right-row)").animate({
			opacity:0
		},500);
		jQuery(".guidance--main .text").animate({
			opacity:0
		},500);

		jQuery(".carousel-indicators > li").removeClass("active");
		jQuery(".carousel-indicators > li."+img).addClass("active");

		jQuery(".right-row").removeClass("active-row");
		jQuery(".right-row."+img).addClass("active-row");

		jQuery(".guidance--main .text."+img).animate({
			opacity:1
		},500);
		jQuery(".image-desktop ."+img+":not(.right-row)").animate({
			opacity:1
		},500);
	}


	function setIpad(){

		if(width<=IpadWidth&&width>=mobileWidth){
			jQuery("body").addClass("touch_parallax");
		}else{
			jQuery("body").removeClass("touch_parallax");
		}
		if(is_touch_device()){
			jQuery(" .header-container-main").hide();
			jQuery(".parallax_height").addClass("parallax_touch");
		}else{
			jQuery(".parallax_height").removeClass("parallax_touch");
		}


		if(width<=IpadWidth&&is_touch_device()&&jQuery('.home').length<1){
			var digitalHeight=jQuery(".digital").outerHeight();
			//var digitalParentHeight = jQuery(".parallax-banking").innerHeight();

			
			

			//jQuery(".black-paral.homepage, .parallax_height").height(digitalHeight);			
			jQuery(".black-paral.homepage, .parallax_height").height(digitalHeight);			

			if(jQuery('.page-template-partners').length>0){
				jQuery(".partners_jumbotron").height(digitalHeight);
			}
			if(jQuery('.single-industry').length>0){
				jQuery(".black-paral.single-industry").height(digitalHeight);
			}
		}
		if(width<=mobileLarge&&is_touch_device()){
			jQuery(".black-paral.success").height(350);
		}

	}

	function animateAwards(scrollTop){
		if(jQuery(".awards-wrapper").length){
			var awardOffset=jQuery(".awards-wrapper").offset().top;
			var awardHeader=jQuery(".awards-wrapper h4");
			var awardImg=jQuery(".awards-wrapper img");

			var vh=jQuery(window).height();
			menu=jQuery(".menu").height();
			if((scrollTop+vh-100)>=awardOffset){
				if(width>=mobileWidth){
					awardHeader.animate({
						opacity:1
					});
					setTimeout(animateImg,300);

					function animateImg(){
						awardImg.animate({
							opacity:1,
							marginTop:0
						},600);
					}
				}else{
					awardHeader.animate({
						opacity:1
					},300,function(){
						awardImg.animate({
							marginTop:0,
							opacity:1
						},600);
					});
				}
			}
		}
	}

	function checkExplorer(){
		var ua=window.navigator.userAgent;
		var trident=ua.indexOf('Trident/');
		var edge=ua.indexOf('Edge/');
		return (trident>0||edge>0);
	}

	function checkMozilla(){
		return (navigator.userAgent.indexOf("Firefox")!==-1);
	}

	function checkChrome(){
		var ua=navigator.userAgent.toLowerCase();
		return (ua.indexOf('chrome')>-1);
	}

	function IsSafari(){
		var is_safari=navigator.userAgent.toLowerCase().indexOf('safari/')>-1;
		return is_safari;
	}

	function setRectangle(){
		var padding;
		var width=jQuery(window).width();
		;
		if(width>=1200){
			padding=45;
		}else{
			padding=15;
		}

		var parent=jQuery(".nav-link.active").parent(".nav-item");

		if(parent.length){
			var offset=parent.offset().left-padding;
			var margin=parent.width()/2+offset;
			jQuery(".rectangle").css("margin-left",margin-10);
		}
	}

	function setVisaBackground(){
		var width=jQuery(window).width();
		if(width<=883){
			jQuery(".visa").addClass("visa-small").removeClass("visa-big");
			jQuery(".visa .col").removeClass("col-md-7");
			jQuery(".awards .award-content").removeClass("pull-left");
		}else{
			jQuery(".visa").removeClass("visa-small").addClass("visa-big");
			jQuery(".awards .award-content").addClass("pull-left");
			jQuery(".visa .col").addClass("col-md-7");
		}
	}
	if(navigator.userAgent.match(/Trident\/7\./)){
		document.body.addEventListener("mousewheel",function(){
			event.preventDefault();
			var wd=event.wheelDelta;
			var csp=window.pageYOffset;
			window.scrollTo(0,csp-wd);
		});
	}

	function setWhiteBox(){
		var wb;
		if(width<=mobileWidth){
			wb=jQuery(".white_box").height()+3;
		}else{
			wb=jQuery(".white_box").height()+90;
		}

		jQuery(".white_box").css("margin-top","-"+wb+"px");
	}

	function setCustomer(){
		if(jQuery(".header-container-customer").length){
			if(width<=800){
				jQuery(".industry_select option.opt_first").html("Industry");
				jQuery(".product_select option.opt_first").html("Platform");
				jQuery(".use_select option.opt_first").html("Use Case");
			}else{
				jQuery(".industry_select option.opt_first").html("Any");
				jQuery(".product_select option.opt_first").html("Any");
				jQuery(".use_select option.opt_first").html("Any");
			}
		}
	}

	function setHeaderCustomer(){
		if(jQuery(window).width()<768){
			var parallax_c_height=jQuery(".homepage__customer").height();
			var header=jQuery(".header__mobile.header-container-customer");
			var header_mobile=header.outerHeight();
			var top=parallax_c_height-header_mobile;
			header.css({ 
				"top":top
			});

		}
	}

	function showModal(){
		jQuery('#video').modal('show');
	}
	jQuery(".customer-content__brand.video_brand").on('click', function(e){
		if(width>mobileLarge){
			e.preventDefault();
			showModal();
		}
	});

	function getRandomTime(){
		var number=Math.random()*(7-3)+3;
		number=Math.floor(number*1000);
		return number;
	}
	(function(jQuery){
		jQuery.rand=function(arg){
			if(jQuery.isArray(arg)){
				return arg[jQuery.rand(arg.length)];
			}else if(typeof arg==="number"){
				return Math.floor(Math.random()*arg);
			}else{
				return 4; // chosen by fair dice roll
			}
		};
	})(jQuery);

	(function(jQuery){
		jQuery.randCustomerParent=function(arg,parentItem){
			if(jQuery.isArray(arg)){
				if(parentItem!=''){
					var index=arg.indexOf(parentItem);
					if(index>-1){
						arg.splice(index,1);
					}
				}
				var selectedItem=arg[jQuery.randCustomerParent(arg.length)];
				return selectedItem;
			}else if(typeof arg==="number"){
				return Math.floor(Math.random()*arg);
			}else{
				return 4; // chosen by fair dice roll
			}
		};
	})(jQuery);

	(function(jQuery){
		jQuery.randCustomerChild=function(arg,visibleItems){
			if(jQuery.isArray(arg)){
				if(visibleItems!=""){
					var difference=[];
					jQuery.grep(arg,function(el){
						if(jQuery.inArray(el,visibleItems)==-1)
							difference.push(el);
					});
					return difference[jQuery.randCustomerChild(difference.length)];
				}else{
					return arg[jQuery.randCustomerChild(arg.length)];
				}
			}else if(typeof arg==="number"){
				return Math.floor(Math.random()*arg);
			}else{
				return 4; // chosen by fair dice roll
			}
		};
	})(jQuery);

	function animation(){
		localStorage.removeItem('company_award');
		localStorage.removeItem('company_award_0');
		localStorage.removeItem('tech_award');
		localStorage.removeItem('tech_award_0');
		var items=[".tech_1 .visible",".tech_2 .visible",".tech_3 .visible",".company_1 .visible",".company_2 .visible",".company_3 .visible"];

		function deleteValue(index,array){
			if(index>-1){
				array.splice(index,1);
			}

		}

		function setItem(item){
			var tech=[];
			var techLength=jQuery('.award_category .category_tech a.awards__wrapper.tech_1').children('div').length;
			for(i=1;i<=techLength;i++){
				tech.push('.award_tech_'+i);
			}

			var company=[];
			var companyLength=jQuery('.award_category .category_comp a.awards__wrapper.company_1').children('div').length;
			for(j=1;j<=companyLength;j++){
				company.push('.award_company_'+j);
			}

			function deleteVisibles(item,array){
				if(jQuery(item).length){
					var itemArr=jQuery(item).attr("class").split(' ')[1];
					var index=(array.indexOf("."+itemArr));
					deleteValue(index,array);

				}
			}
			var item=item;
			if(typeof jQuery(item).parent().attr("class")!='undefined'){
				var cl=jQuery(item).parent().attr("class").split(' ')[1];
				cl="."+cl;
			}

			if(cl==".tech_1"||cl==".tech_2"||cl==".tech_3"){
				var category="tech";
				var totalArray=tech;
			}else{
				var category="company";
				var totalArray=company;
			}
			var totalAward=localStorage.getItem(category+"_award");
			var totalAward_0=localStorage.getItem(category+"_award_0");
			if(totalAward!=null){
				var index=(totalArray.indexOf(totalAward));
				deleteValue(index,totalArray);
			}
			if(totalAward_0!=null){
				var index=(totalAward_0.indexOf(totalAward));
				deleteValue(index,totalArray);
			}

			deleteVisibles("."+category+"_1 .visible.award",totalArray);
			deleteVisibles("."+category+"_2 .visible.award",totalArray);
			deleteVisibles("."+category+"_3 .visible.award",totalArray);

			var subItem=jQuery.rand(totalArray);
			if(totalAward!=null){
				localStorage.setItem(category+"_award_0",totalAward);
			}
			localStorage.setItem(category+"_award",subItem);
			jQuery(cl+" .award").removeClass("visible");
			setTimeout(add,1500);

			function add(){
				jQuery(cl+" "+subItem).addClass("visible");
			}

			function set(){
				setItem(item); /* recursion */
			}
			setTimeout(set,getRandomTime());
			
		}

		function setAward(item,i){
			setTimeout(function(){
				setItem(item);
			},1000*i);
		}

		var parentItem=jQuery.rand(items);
		var ind=(items.indexOf(parentItem));
		deleteValue(ind,items);
		setItem(parentItem);

		for(var i=0;i<=4;i++){
			var parentItem=jQuery.rand(items);
			var ind=(items.indexOf(parentItem));
			deleteValue(ind,items);
			setAward(parentItem,i);
		}
	}

	function animationCustomer(){
		function setItemC(){
			var customer=[];
			var customerLength=jQuery('.award_category .customer_award a.awards__wrapper.customerA_1').children('div').length;
			for(k=1;k<=customerLength;k++){
				customer.push('.award_customer_'+k);
			}
			var parentItem='';

			function runItemC(){

				var itemsC=[".customerA_1",".customerA_2",".customerA_3"];
				var clC=jQuery.randCustomerParent(itemsC,parentItem);
				parentItem=clC;
				var visibleItems=[];
				jQuery(".customer_award").find(".visible").each(function(){
					if(jQuery(this).attr('class').split(' ')[2]!=undefined){
						visibleItems.push('.'+jQuery(this).attr('class').split(' ')[2]);
					}
				});

				var subItemC=jQuery.randCustomerChild(customer,visibleItems);
				jQuery(clC+" .awardC").removeClass("visible");

				function addC(){
					jQuery(clC+" "+subItemC).addClass("visible");
				}
				setTimeout(addC,1500);
			}
			runItemC();
			setInterval(runItemC,2000);
		}
		setTimeout(setItemC,1500);
	}

	function setBackgroundHandler(){
		var images=[".parallax",".parallax_height",
			".jumbotron_banner__poster",
			".parallax-success"
		];
		for(var i=0;i<images.length;i++){
			var parallax=images[i];
			if(jQuery(parallax).length){
				loadImage(parallax);
			}
		}

		function loadImage(parallax){
			var a=new Image();
			a.onload=function(){
				finished();
			};
			var str=jQuery(parallax).css('background-image');
			str=str.replace('url(','').replace(')','').replace(/\"/gi,"");
			a.src=str;
		}

	}

	function removeTextLabels(){
		var slick=jQuery(".slick-arrow");
		if(slick.length){
			slick.html("");
		}
	}

	function setSuccessTemplate(){
		var success=jQuery(".parallax-success .digital"),
		succesH,blackParal;
		if(success.length){
			blackParal=jQuery(".black-paral").height();
			succesH=success.outerHeight();
			success.css({
				"top":blackParal+-succesH-20+"px"
			})
		}
	}

	function setCareers(){
		var aHeight=jQuery(".blue_content").outerHeight();
		jQuery(".article_image").css("height",aHeight);
	}

	function EventsHeightBoxes_notinuse(){
		jQuery(".calendar__parent").each(function(index){
			
			var textHeight=[];
			var current=jQuery(".calendar__parent").eq(index);
			// jQuery(current+" .calendar__child").each(function(index){
				// var height = parseInt(jQuery(this + " .event-date").height());
				// textHeight.push(height)
			// });
			
		});
	}

	function OpenCubes(){
		jQuery(".cubes__content").slideUp();
		jQuery(".open_cubes").on('click', function(){
			jQuery(this).parent().find(".cubes__content").slideToggle();
			jQuery(this).parent().toggleClass("cubes__closed");
		});
	}

	function setVideo(){
		var vid=document.getElementById("homepage_video");
		if(vid!=null){
			vid.playbackRate=0.6;
		}
	}

	//EventsHeightBoxes();
	launchCarousel();
	jumbotronManage();
	setVisaBackground();
	jQuery(window).on('resize', resizeEvents);
	setScrollEvents();
	setNavs();
	setMouseOverEvents();
	setClickEvents();
	setRectangle();
	setGuidance();
	//setWhiteBox();
	setIpad();
	setCustomer();
	setMarginSubMenu();
	setCareers();
	setParallax();
	removeParallaxSmall();
	setHeaderCustomer();
	setBackgroundHandler();
	setSuccessTemplate();
	setDapHeight();
	if(jQuery(".awards__section").length){
		animation();
		animationCustomer();
	}
	removeTextLabels();
	OpenCubes();
	setVideo();
	//GA EVENTS
	// window['GoogleAnalyticsObject']='ga';
	// window['ga']=window['ga']||function(){
	// 	(window['ga'].q=window['ga'].q||[]).push(arguments);
	// };
	
	// var dataEvent;
	// var isLp=jQuery('body').is('[class^="lp"]');
	// jQuery('.popup-signup, .popup-demo, .popup-goute, .popup-meet, .pop-footer-cloned, .pop-top-cloned').on('click', function(){
	// 	dataEvent=isLp ? "landingpformopen" : jQuery(this).attr('data-event');
	// 	localStorage.setItem('dataEvent',dataEvent);
	// 	ga('send','event','form','click',dataEvent);
	// });
	//END GA EVENTS
});

function setParallax(){
	var digitalHeight=jQuery(".digital").innerHeight();
	jQuery(".parent__parallax, .parallax-resize").height(digitalHeight);
}

function finished(){
	animateBigText();
	setTimeout(animateSmallText,400);
	setTimeout(animateButtons,1400);
	setTimeout(animateText,2100);
	setTimeout(animateWatch,2800);

	function animateWatch(){
		jQuery(".watch").css({
			"-webkit-animation-name":"fadeIn",
			"animation-name":"fadeIn",
			"opacity":1
		});
	}

	function animateBigText(){
		jQuery(".bigtext").css({
			"-webkit-animation-name":"fadeInDown",
			"animation-name":"fadeInDown",
			"opacity":1
		});
	}

	function animateSmallText(){
		jQuery(".smalltext").css({
			"-webkit-animation-name":"fadeInDown",
			"animation-name":"fadeInDown",
			"opacity":1
		});
	}

	function animateButtons(){
		jQuery(".free, .demo, .button_animated").css({
			"-webkit-animation-name":"fadeIn",
			"animation-name":"fadeIn",
			"opacity":1
		});
	}

	function animateText(){
		jQuery(".header-content ").css({
			"-webkit-animation-name":"fadeIn",
			"animation-name":"fadeIn",
			"opacity":1
		});
	}
	if(is_touch_device()){
		if(jQuery(".digital-platform").length){
			showSecondSection();
		}

		function showSecondSection(){
			jQuery(".digital-platform .walkme-digital").css({
				"-webkit-animation-name":"fadeIn",
				"animation-name":"fadeIn",
				"opacity":1
			});
			setTimeout(fadeOutBasic1,700);
			setTimeout(fadeOutBasic2,900);
			setTimeout(fadeOutBasic3,1100);
		}
	}
}

function setDapHeight(){
	if(jQuery('.page-template-walkme-platform').length){
		//jQuery('.sp-tabs-images-block').height(jQuery('.sp-tab-image-layer').height());
		//jQuery('.sp-tabs-images-block').height(jQuery('.sp-tab-image-bg').height());
	}
}
//jQuery(document).ready(function(){
//var width=parseInt(jQuery(window).outerWidth())+12;
//var height=parseInt(jQuery(window).outerHeight())+20;
//window.resizeTo(width,height);
//});

// jQuery(window).on('resize', function(){
// 	setIpad();
// });